import { Alert, Chip, Stack, Typography } from "@mui/material";

import type { ClientCdpProfileResponse } from "../../../../lib/api/types";

const clientTypeLabels: Record<string, string> = {
    b2c: "B2C",
    b2b: "B2B",
    mixed: "Смесен",
};

const matchTypeLabels: Record<string, string> = {
    phone: "телефон",
    eik: "ЕИК",
    email: "имейл",
    loyalty_card: "карта",
};

export default function Client360CdpMasterBanner({ cdp }: { cdp: ClientCdpProfileResponse }) {
    const master = cdp.master;
    const pendingCount = master?.pendingMergeCount ?? 0;

    return (
        <Alert severity="info" sx={{ mb: 2 }}>
            <Stack spacing={1}>
                <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }} useFlexGap>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Клиентски профил
                    </Typography>
                    <Chip size="small" label="Данни на живо от ERP" variant="outlined" />
                    {master ? (
                        <Chip size="small" label={clientTypeLabels[master.clientType] ?? master.clientType} />
                    ) : null}
                    {cdp.mergeTableReady ? (
                        <Chip size="small" label="Merge таблица" color="success" variant="outlined" />
                    ) : null}
                    {pendingCount > 0 ? (
                        <Chip size="small" color="warning" label={`${pendingCount} предложения за свързване`} />
                    ) : null}
                </Stack>

            </Stack>
        </Alert>
    );
}

export function matchTypeLabel(matchType: string) {
    return matchTypeLabels[matchType] ?? matchType;
}
